﻿(function (angular, ToyotaForms) {
    'use strict';

    angular
        .module('Toyota.Directives')
        .directive('formsContactADealer', ['$filter', 'API', function ($filter, API) {
            formsContactADealerController.$inject = ['$scope', '$location', '$attrs', 'PricingSendToDealerAutofill', 'DisclaimersService'];
            function formsContactADealerController($scope, $location, $attrs, PricingSendToDealerAutofill, DisclaimersService) {
                var CAR_SELECTION_ONE_PARAM_KEY = 'CarSelectionOne';
                var DEEPLINK_SEND_TO_DEALER_AUTOFILL_TOKEN = '{@pricingMessage@}';
                var MATERIAL_CODE_PARAM_KEY = 'material_code';

                var carSelectionOneParam = $location.search()[CAR_SELECTION_ONE_PARAM_KEY];
                var materialCodeParam = $location.search()[MATERIAL_CODE_PARAM_KEY];
                var selectionToUrlMapping = JSON.parse($attrs.webglSpinnerUrls);
                var deeplinkAutofillData = $attrs.deeplinkAutofill ? JSON.parse($attrs.deeplinkAutofill) : null;
                var lastDisplayedMessage = '';

                $scope.init = function () {
                    $scope.fields = {
                        firstname: '',
                        lastname: '',
                        postcode: '',
                        phone: '',
                        email: '',
                        carSelectionOne: '',
                        postCodeOrSuburb: '',
                        dealer: {
                            dealerCode: '',
                            branchCode: '',
                            address: '',
                            name: '',
                            postCode: '',
                            suburb: '',
                            state: '',
                            telephone: '',
                            email: ''
                        },
                        dealerSelected: false,
                        agreement: false,
                        buyingTimeline: '',
                        message: '',
                        enquiryType: ''
                    };

                    $scope.fieldsMeta = {
                        messageReadOnly: false
                    };

                    $scope.form = {
                        submitting: false,
                        completed: false,
                        success: false
                    };

                    $scope.vehicleModelList = ['carSelectionOne'];

                    if (deeplinkAutofillData) {
                        initialiseDeeplinkAutofill(deeplinkAutofillData);
                        initialiseFinanceDisclaimers();
                    }
                    else {
                        initialiseMessageAutofill();
                    }
                };

                $scope.init();

                function initialiseFinanceDisclaimers() {
                    var localstorageAutofillData = PricingSendToDealerAutofill.get();
                    if (localstorageAutofillData && localstorageAutofillData.disclaimers) {
                        DisclaimersService.ingestDisclaimersArrayToGroup(localstorageAutofillData.disclaimers, 'pricing-send-to-dealer');
                        DisclaimersService.showGroup('pricing-send-to-dealer');
                    }
                }

                function applyLocalStorageAutofillToDeeplinkAutofill(deeplinkAutofillData) {
                    var combinedAutofillData = angular.copy(deeplinkAutofillData);
                    var localstorageAutofillData = PricingSendToDealerAutofill.get();

                    if (localstorageAutofillData) {
                        combinedAutofillData.enquiry_type = localstorageAutofillData.enquiryType;
                        combinedAutofillData.message = deeplinkAutofillData.message.replace(DEEPLINK_SEND_TO_DEALER_AUTOFILL_TOKEN, localstorageAutofillData.message || '');
                        if (localstorageAutofillData.vehicleModel) {
                            combinedAutofillData.model = localstorageAutofillData.vehicleModel;
                        }
                    }

                    return combinedAutofillData;
                }

                var vehicleModelList;

                function findVehicleModelValue(selected) {
                    if (!selected) {
                        return null;
                    }

                    if (!vehicleModelList) {
                        vehicleModelList = JSON.parse($attrs.formsContactADealerVehicleModelList);
                    }

                    var vehicleModel = vehicleModelList.find(function (vehicleModel) {
                        return selected === vehicleModel.ModelId || selected.toLowerCase() === vehicleModel.Text.toLowerCase();
                    });

                    return vehicleModel ? vehicleModel : null;
                }

                function initialiseDeeplinkAutofill(deeplinkAutofillData) {
                    var combinedAutofillData = applyLocalStorageAutofillToDeeplinkAutofill(deeplinkAutofillData);
                    $scope.fields.enquiryType = combinedAutofillData.enquiry_type;
                    $scope.fields.message = combinedAutofillData.message;

                    if (combinedAutofillData.message_read_only.toLowerCase() === 'true') {
                        $scope.fieldsMeta.messageReadOnly = true;
                    }

                    if (combinedAutofillData.model && combinedAutofillData.model !== '') {
                        var modelFound = findVehicleModelValue(combinedAutofillData.model);
                        $scope.fields.carSelectionOne = modelFound ? modelFound.Value || '' : '';
                    }
                }

                function initialiseMessageAutofill() {
                    var $carSelectionOne = findVehicleModelValue(carSelectionOneParam) || '';

                    if (!$attrs.webglSpinnerUrls || !$attrs.messageAutofill || $carSelectionOne.length === 0
                        || typeof materialCodeParam === 'undefined') {
                        return;
                    }

                    $scope.$watch('fields.carSelectionOne', function () {
                        updateMessageAutofill($carSelectionOne.Text);
                    });
                }

                function updateMessageAutofill(carSelection) {
                    var vehicleModel = selectionToUrlMapping.find(function (mapping) {
                        return mapping.Name.toLowerCase() === carSelection.toLowerCase();
                    });

                    if (!vehicleModel || !vehicleModel.WebGLSpinnerUrl || carSelection.toLowerCase() !== carSelectionOneParam.toLowerCase()) {
                        if ($scope.fields.message === lastDisplayedMessage) {
                            $scope.fields.message = '';
                        }
                        return;
                    }

                    if ($scope.fields.message === '' || $scope.fields.message === lastDisplayedMessage) {
                        var message = $attrs.messageAutofill + ' ' + carSelection + ' - ' + vehicleModel.WebGLSpinnerUrl;

                        if (materialCodeParam) {
                            message = message + '?' + MATERIAL_CODE_PARAM_KEY + '=' + materialCodeParam;
                        }

                        lastDisplayedMessage = message;
                        $scope.fields.message = message;
                    }
                }

                $scope.vehicleInvalid = function (fieldId, isRequired) {
                    // only validate while the user is filling the form
                    if (!isRequired) {
                        return false;
                    }

                    if (!$scope.wfm[fieldId].$touched && !$scope.wfm.$submitted) {
                        return false;
                    }

                    return !$scope.wfm[fieldId].$valid;
                };

                $scope.vehicleValid = function (fieldId, isRequired) {
                    if (!isRequired) {
                        return false;
                    }

                    // only validate while the user is filling the form
                    if (!$scope.wfm[fieldId].$touched) {
                        return false;
                    }

                    return $scope.wfm[fieldId].$valid;
                };

                $scope.setPreferredDealer = function (dealer) {
                    $scope.fields.dealerSelected = true;
                    $scope.fields.dealer.dealerCode = dealer.dealerCode;
                    $scope.fields.dealer.branchCode = dealer.branchCode;
                    $scope.fields.dealer.name = dealer.name;
                    $scope.fields.dealer.address = dealer.address;
                    $scope.fields.dealer.suburb = dealer.city;
                    $scope.fields.dealer.postCode = dealer.postCode;
                    $scope.fields.dealer.state = dealer.state;
                    $scope.fields.dealer.telephone = dealer.telephone;
                    $scope.fields.dealer.email = dealer.email;
                };

                $scope.getData = function () {
                    var agreement;
                    if ($('#terms-checkbox').length) {
                        agreement = $scope.fields.agreement;
                    }
                    else {
                        agreement = true;
                    }
                    return {
                        FirstName: $scope.fields.firstname,
                        LastName: $scope.fields.lastname,
                        Email: $scope.fields.email,
                        Phone: $scope.fields.phone,
                        CarSelectionOne: $scope.fields.carSelectionOne,
                        Dealer: {
                            Id: $scope.fields.dealer.dealerCode,
                            BranchId: $scope.fields.dealer.branchCode,
                            Name: $scope.fields.dealer.name,
                            Address: $scope.fields.dealer.address,
                            State: $scope.fields.dealer.state,
                            Postcode: $scope.fields.dealer.postCode,
                            Suburb: $scope.fields.dealer.suburb,
                            Telephone: $scope.fields.dealer.telephone,
                            Email: $scope.fields.dealer.email
                        },
                        Address: $scope.fields.postCodeOrSuburb,
                        BuyingTimeLine: $scope.fields.buyingTimeline,
                        Agreement: agreement,
                        EnquiryType: $scope.fields.enquiryType,
                        Message: $scope.fields.message,
                        FormName: $scope.fields.formName,
                        CampaignCode: $scope.fields.campaignCode
                    };
                };

                $scope.submit = function () {
                    if (!$scope.fields.dealerSelected) {
                        $scope.form.completed = true;
                        $scope.form.success = false;
                        return;
                    }

                    $scope.form.submitting = true;

                    var url = $filter('formatArgs')(ToyotaForms.API.FormSubmission.ContactADealer);
                    var data = $scope.getData();

                    API.post(url, data)
                        .then(function (req) {
                            $scope.form.submitting = false;

                            if (req.data.isSuccessful) {
                                $scope.form.completed = true;
                                $scope.form.success = true;
                            } else {
                                $scope.form.completed = true;
                                $scope.form.success = false;
                            }

                            if ($scope.form.completed && $scope.form.success) {
                                $scope.$broadcast('form-success');
                            } else {
                                $scope.$broadcast('form-failure');
                            }
                        }, function () {
                            $scope.form.completed = true;
                            $scope.form.success = false;
                            $scope.$broadcast('form-server-error');
                        });
                };
            }

            return {
                scope: true,
                restrict: 'A',
                controller: formsContactADealerController,
                controllerAs: 'fc',
                bindToController: true,
                link: function (scope, element, attrs) {
                }
            };
        }]);
})(window.angular, window.ToyotaForms);
